import { AppState } from "../app.state";

export const getPlanFerkelStatus = (state: AppState) => state.planFerkel.loadStatus;

export const getLastFetchedDate = (state: AppState) => state.planFerkel.lastFetched;
